/**
 * Converts Number to AU Local currecy string
 * @param {Number} amount - Number to format
 * @returns Formated price
 */
export const toAudString = (amount) => amount.toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
